import React from 'react';
import { arrayOf, any, func, bool } from 'prop-types';

import { envConfigSelectors } from '~/components';
import { connect } from 'react-redux';
import { triggerPreferredAppointmentTypeChosen } from '../../analytics/analytics.listener';

export const withAnalytics =
  (trackEvent = triggerPreferredAppointmentTypeChosen) =>
  (Component) =>
    class ComponentWithAnalytics extends React.PureComponent {
      static propTypes = {
        defaultValue: arrayOf(any),
        onChange: func.isRequired,
        isEligibleForAnalytics: bool,
      };

      static defaultProps = {
        defaultValue: [],
        isEligibleForAnalytics: false,
      };

      componentDidMount() {
        const { isEligibleForAnalytics, defaultValue } = this.props;

        if (isEligibleForAnalytics) {
          defaultValue.forEach((value) => trackEvent(value));
        }
      }

      handleChange = (event) => {
        const { onChange } = this.props;
        trackEvent(event.target.value);
        onChange(event);
      };

      render() {
        const { isEligibleForAnalytics, onChange } = this.props;
        return (
          <Component
            {...this.props}
            onChange={isEligibleForAnalytics ? this.handleChange : onChange}
          />
        );
      }
    };

const mapStateToProps = (state, { id }) => ({
  isEligibleForAnalytics: id.endsWith(envConfigSelectors.selectHowWeContactYouQuestionId(state)),
});

export const ConnectedWithAnalytics = (trackEvent) => (Component) =>
  connect(mapStateToProps)(withAnalytics(trackEvent)(Component));
